module.exports = __webpack_public_path__ + "static/media/orion-gray.49e424ee.png";